import React from 'react';
import type { GamificationEventsSummary, GamificationPeriod } from '@troia-v3/types';

import { Icon, type IconName } from '@/shared/icons';
import { periodInLabel } from '@/shared/utils/gamificationPeriod';

const fmt = (n: number): string => new Intl.NumberFormat('pt-BR').format(n);

const Kpi: React.FC<{ icon: IconName; purple?: boolean; label: string; value: string; foot: string; testId: string }> = ({ icon, purple, label, value, foot, testId }) => (
  <div className="gm-kpi" data-testid={testId}>
    <div className="gm-kpi-top"><span className={`gm-kpi-ic ${purple ? 'gm-kpi-ic--purple' : ''}`}><Icon name={icon} size={16} /></span><span className="gm-kpi-lbl">{label}</span></div>
    <div className="gm-kpi-val">{value}</div>
    <div className="gm-kpi-foot"><span>{foot}</span></div>
  </div>
);

/** 4 KPIs da auditoria (mockup 10 B `.kpi-row`). O rótulo do 1º acompanha o período configurado ("no mês" é a copy do mockup, que usa `month`). */
export const AuditKpis: React.FC<{ summary?: GamificationEventsSummary; period?: GamificationPeriod }> = ({ summary, period = 'month' }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-[18px]" data-testid="gamification-audit-kpis">
    <Kpi icon="star" purple label={`Confirmados ${periodInLabel(period)}`} value={fmt(summary?.confirmedPoints ?? 0)} foot={`${summary?.confirmedUsers ?? 0} vendedores`} testId="gamification-audit-kpi-confirmed" />
    <Kpi icon="clock" label="Pendentes" value={fmt(summary?.pendingCount ?? 0)} foot="aguardando WhatsApp" testId="gamification-audit-kpi-pending" />
    <Kpi icon="refresh" label="Estornados" value={fmt(summary?.reversedPoints ?? 0)} foot={`${summary?.reversedCount ?? 0} vendas canceladas`} testId="gamification-audit-kpi-reversed" />
    <Kpi icon="alert-triangle" label="Capturas sem formulário" value={fmt(summary?.capturesWithoutForm ?? 0)} foot="vale olhar" testId="gamification-audit-kpi-noform" />
  </div>
);
AuditKpis.displayName = 'AuditKpis';
